import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { State, getSelectedPressNewsId } from '@app/app.reducer';
import { GetPressNewsById } from '@app/press-news/press-news.actions';
import { Store } from '@ngrx/store';
import { ErrorHandlingService } from '@shared/error-handling/error-handling.service';
import { StatusBarService } from '@shared/status-bar/status-bar.service';
import { environment } from '@src/environments/environment';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PressNewsService {
  pressNewsId$: Observable<number>;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService,
    private statusBarService: StatusBarService,
    private store: Store<State>
  ) {
    this.pressNewsId$ = this.store.select(getSelectedPressNewsId);
    this.pressNewsId$.subscribe((pressNewsId) => {
      this.store.dispatch(new GetPressNewsById(pressNewsId));
    });
  }

  getPressNewsList(eventId) {
    return this.http.get(`${environment.webApiUrl}/event/${eventId}/completed-page`).pipe(
      map((res) => {
        try {
          return res;
        } catch (err) {
          this.statusBarService.setStatus(err, 'error');
        }
      }),
      catchError((e) => {
        return this.errorHandlingService.errorHandler(e);
      })
    );
  }

  getPressNews(eventId) {
    return this.http.get(`${environment.webApiUrl}/press-release/${eventId}`).pipe(
      map((res) => {
        try {
          return res;
        } catch (err) {
          this.statusBarService.setStatus(err, 'error');
        }
      }),
      catchError((e) => {
        return this.errorHandlingService.errorHandler(e);
      })
    );
  }
}
